import React from "react";
import { Box, MenuItem, TextField, Typography } from "@mui/material";

export const LOCATION_CONTENT_LANGUAGES = [
  { code: "en", label: "English — default/fallback" },
  { code: "hn", label: "Hinglish" },
  { code: "hi", label: "Hindi" },
  { code: "bn", label: "Bengali" },
  { code: "gu", label: "Gujarati" },
  { code: "kn", label: "Kannada" },
  { code: "mr", label: "Marathi" },
  { code: "ta", label: "Tamil" },
  { code: "te", label: "Telugu" },
];

export const getLocationContentByLanguage = (item = {}) => Object.fromEntries(
  LOCATION_CONTENT_LANGUAGES.map(({ code }) => [code, code === "en" ? item.content || "" : item.pageContentTranslations?.[code]?.content || ""])
);

export const hasUsableLocationContent = (value = "") => value
  .replace(/<[^>]*>/g, "")
  .replace(/&nbsp;|\s/g, "")
  .length > 0;

export const switchLocationContentLanguage = ({ language = "en", nextLanguage = "en", storedContent = {}, content = "", onLanguageChange = () => {}, confirmDiscard = () => true } = {}) => {
  if (content !== (storedContent[language] || "") && !confirmDiscard()) return false;
  onLanguageChange(nextLanguage, storedContent[nextLanguage] || "");
  return true;
};

export const getLocationContentRequestPayload = ({ jobLocationContentId = "", language = "en", content = "", englishPayload = {} } = {}) => (
  language === "en" ? englishPayload : { jobLocationContentId, pageContentLanguage: language, content }
);

const JobLocationContentLanguageEditor = ({ language = "en", storedContent = {}, content = "", onLanguageChange = () => {} }) => {
  const handleChange = (event) => switchLocationContentLanguage({
    language,
    nextLanguage: event.target.value,
    storedContent,
    content,
    onLanguageChange,
    confirmDiscard: () => window.confirm("Discard unsaved page-content changes?"),
  });

  return <>
    <Box sx={{ mb: 2 }}>
      <TextField select fullWidth size="small" label="Page content language" value={language} onChange={handleChange}>
        {LOCATION_CONTENT_LANGUAGES.map(({ code, label }) => <MenuItem key={code} value={code}>{label}</MenuItem>)}
      </TextField>
    </Box>
    {language !== "en" && !hasUsableLocationContent(content) ? <Box sx={{ mb: 2 }}><Typography variant="caption" color="text.secondary">Translation missing; English will be displayed as fallback.</Typography></Box> : null}
  </>;
};

export default JobLocationContentLanguageEditor;
